import { render, staticRenderFns } from "./ClickableList.vue?vue&type=template&id=978cd3f8&"
import script from "./ClickableList.vue?vue&type=script&lang=js&"
export * from "./ClickableList.vue?vue&type=script&lang=js&"
import style0 from "./ClickableList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports